import styled from "@emotion/styled";
import { Container, Grid, Link } from "@mui/material";
import React from "react";
import { Image } from "../../../../Styles/style";
import SectionsHeading from "../../SectionsHeading";
import Paragraph from "../../Paragraph";
import image1 from "../../../../../assets/Images/X.png";
import image2 from "../../../../../assets/Images/colorTelegram.png";
import image3 from "../../../../../assets/Images/colorMedium.png";
import Marquee from "react-fast-marquee";

const ContinerWraper = styled(Container)`
  position: relative;
  height: auto;
  width: 100%;
  padding: 130px 0 !important;
`;


const CommunitySection = () => {
  return (
    <ContinerWraper maxWidth="xxl" id="comunity">
      <Container>
        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "center",
            rowGap: "20px",
            zIndex: "1",
            columnGap: "30px",
          }}
        >
          <Grid item xs={12}>
            <SectionsHeading
              ta="left"
              fs="46px"
              fs599="46px"
              color="#FC9C00 !important"
            >
              Join The Community
            </SectionsHeading>
          </Grid>
          <Marquee>
            <div
              style={{
                display: "flex",
                flexBasis: "33%",
                alignItems: "center",
                m: "0 20px !important",
              }}
            >
              <Link href="https://twitter.com/shialending" sx={{textDecoration:"none" , cursor:"pointer"}} ><Image mw="100px" src={image1} m="0 20px" /></Link>
              <div style={{ margin: "0 20px !important" }}>
                <SectionsHeading
                  ta="left"
                  fs="14px"
                  fs599="14px"
                  color="#FC9C00 !important"
                >
                  Stay up to date.
                </SectionsHeading>
                <SectionsHeading ta="left" fs="24px" fs599="24px" fm="PoppinsR">
                  Loading...
                </SectionsHeading>
                <Paragraph p="0" fs="12px" ta="left">
                  Followers
                </Paragraph>
              </div>
            </div>
            <div style={{ m: "0 20px !important" }}>
            <Image style={{visibility:"hidden"}} mw="100px" src={image3} m="0 20px" />
              </div>
            <div
              style={{
                display: "flex",
                flexBasis: "33%",
                alignItems: "center",
              }}
            >
              <Link   href="https://t.me/shialending" sx={{textDecoration:"none" , cursor:"pointer"}} ><Image mw="100px" src={image2} m="0 20px" /></Link>
              <div style={{ m: "0 20px !important" }}>
                <SectionsHeading
                  ta="left"
                  fs="14px"
                  fs599="14px"
                  color="#FC9C00 !important"
                >
                  24/7 Global chat and support.
                </SectionsHeading>
                <SectionsHeading ta="left" fs="24px" fs599="24px" fm="PoppinsR">
                  Loading...
                </SectionsHeading>
                <Paragraph p="0" fs="12px" ta="left">
                  Followers
                </Paragraph>
              </div>
            </div>
            <div style={{ m: "0 20px !important" }}>
            <Image style={{visibility:"hidden"}} mw="100px" src={image3} m="0 20px" />
              </div>
            <div
              style={{
                display: "flex",
                flexBasis: "33%",
                alignItems: "center",
              }}
            >
              <Link sx={{textDecoration:"none" , cursor:"pointer"}} ><Image mw="100px" src={image3} m="0 20px" /></Link>
              <div style={{ m: "0 20px !important" }}>
                <SectionsHeading
                  ta="left"
                  fs="14px"
                  fs599="14px"
                  color="#FC9C00 !important"
                >
                  Get Shia Vault updates at your own pace.
                </SectionsHeading>
                <SectionsHeading ta="left" fs="24px" fs599="24px" fm="PoppinsR">
                  Loading...
                </SectionsHeading>
                <Paragraph p="0" fs="12px" ta="left">
                  Followers
                </Paragraph>
              </div>
            </div>
            <div style={{ m: "0 20px !important" }}>
            <Image style={{visibility:"hidden"}} mw="100px" src={image3} m="0 20px" />
              </div>
          </Marquee>
        </Grid>
      </Container>
    </ContinerWraper>
  );
};

export default CommunitySection;
